<template>
  <div>
    <div class="wrapper">
      <div class="toggle_radio">
        <input type="radio" class="toggle_option" id="_first_toggle" name="_toggle_option" checked="checked"/>
        <input type="radio" class="toggle_option" id="_second_toggle" name="_toggle_option"/>
        <input type="radio" class="toggle_option" id="_third_toggle" name="_toggle_option"/>

        <label for="_first_toggle" @click="progress(0)"><p>{{ $t("competencyProgress.threeStepToggle.tst1") }}</p></label>
        <label for="_second_toggle" @click="progress(1)"><p>{{ $t("competencyProgress.threeStepToggle.tst2") }}</p></label>
        <label for="_third_toggle" @click="progress(2)"><p>{{ $t("competencyProgress.threeStepToggle.tst3") }}</p></label>
        <div class="toggle_option_slider">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TwoStepToggle",
  props: ["q"],
  data() {
    return {
      saved: null
    }
  },
  methods: {
    progress(i) {
      let value = 100;
      if (i === 0) value = 100;
      else if (i === 1) value = 50;
      else if (i === 2) value = 0;
      else if (i === 3) value = 25;
      const progressObj = {
        q: this.q,
        value
      }
      this.$store
        .dispatch("competencyProgress/calculate", progressObj)
        .then(res => {
          console.log("progress calculate", res);
          console.log(this.$store.state.competencyProgress);
        })
        .catch(err => {
          console.log("error progress calculate", err);
        });
    }
  }
};
</script>

<style scoped>
  /*@import url(http://fonts.googleapis.com/css?family=Source+Sans+Pro);*/
  /*.wrapper {
    margin: 100px 0;
  }*/
  .toggle_radio{
    position: relative;
    background: linear-gradient(19deg, rgba(var(--vs-primary),0.4) 28%, rgba(var(--vs-primary),0.6) 50%, rgba(var(--vs-primary),1) 100%); /*rgba(255,255,255,.1)*/
    margin: 4px auto;
    overflow: hidden;
    padding: 0 !important;
    -webkit-border-radius: 50px;
    -moz-border-radius: 50px;
    border-radius: 50px;
    height: 56px;
    width: 100%;
  }
  .toggle_radio > * {
    float: left;
  }
  .toggle_radio input[type=radio]{
    display: none;
    /*position: fixed;*/
  }
  .toggle_radio label{
    font: 90%/1.618 Montserrat, Helvetica, Arial, sans-serif;
    font-size: 13px;
    color: rgba(255,255,255,.9);
    z-index: 0;
    display: block;
    width: 33.33%;
    height: 50px;
     -webkit-border-radius: 50px;
    -moz-border-radius: 50px;
    border-radius: 50px;
    cursor: pointer;
    z-index: 1;
    /*background: rgba(0,0,0,.1);*/
    text-align: center;
    /*margin: 0 2px;*/
    /*background: blue;*/ /*make it blue*/
  }
  .toggle_radio label p {
    padding: 12px 0px;
   }
  .toggle_option_slider{
    /*display: none;*/
    /*background: red;*/
    width: /*100px;*/ 33.33%;
    height: 50px;
    position: absolute;
    top: 3px;
    -webkit-border-radius: 50px;
    -moz-border-radius: 50px;
    border-radius: 50px;
    -webkit-transition: all .4s ease;
    -moz-transition: all .4s ease;
    -o-transition: all .4s ease;
    -ms-transition: all .4s ease;
    transition: all .4s ease;
  }

  input[id $='_first_toggle']:checked ~ .toggle_option_slider{
    background: rgba(255,255,255,.3);
    left: 0px;
  }
  input[id $= '_second_toggle']:checked ~ .toggle_option_slider{
    background: rgba(255,255,255,.3);
    left: /*109px*/ 33.33%;
  }
  input[id $= '_third_toggle']:checked ~ .toggle_option_slider{
    background: rgba(255,255,255,.3);
    left: /*215px;*/ 66.66%;
  }
</style>
